export const SET_HERE_MAPS_PLATFORM = 'SET_HERE_MAPS_PLATFORM'
export const SET_HERE_MAPS_ROUTING = 'SET_HERE_MAPS_ROUTING'
export const SET_HERE_MAPS_DEFAULT_LAYER = 'SET_HERE_MAPS_DEFAULT_LAYER'
export const SET_HERE_MAPS_MAP = 'SET_HERE_MAPS_MAP'
export const SET_HERE_MAPS_MAP_BEHAVIORS = 'SET_HERE_MAPS_MAP_BEHAVIOR'
export const SET_HERE_MAPS_MARKERS = 'SET_HERE_MAPS_MARKERS'
export const SET_IS_MAP_INITIALIZING = 'SET_IS_MAP_INITIALIZING'
export const SET_IS_MAP_ROUTING = 'SET_IS_MAP_ROUTING'
export const SET_MAP_ROUTING_OPTIONS_MARKERS = 'SET_MAP_ROUTING_OPTIONS_MARKERS'

export const SET_RESET_STATE = 'SET_RESET_STATE'
